<template>
    <article
        v-if="names && guidelineId"
        class="guideline-reference-tooltip"
    >
        <header class="guideline-reference-tooltip__header">
            <h4>Reference</h4>

            <a
                href="#"
                class="guideline-reference-tooltip__close"
                aria-label="Close reference"
                @click.prevent="close"
            >
                <BaseIcon icon="close" />
            </a>
        </header>

        <div
            v-if="!pending"
            class="guideline-reference-tooltip__content"
        >
            <p
                v-for="(reference, index) in references"
                :key="`reference${index}`"
            >
                {{ reference.content }}

                <template v-if="reference.url">
                    <br>
                    <a
                        :href="reference.url"
                        target="blank"
                        rel="noopener noreferrer"
                    >
                        {{ reference.url }}
                    </a>
                </template>
            </p>
            <p v-if="!references.length">
                Reference not found.
            </p>
        </div>

        <content-placeholders
            v-else
            class="guideline-reference-tooltip__content"
        >
            <content-placeholders-text :lines="3" />
        </content-placeholders>
    </article>
</template>

<script setup>
import ReferenceTooltipQuery from '~/graphql/queries/guidelines/reference-tooltip.graphql';

const props = defineProps({
    guidelineId: {
        type: [String, Number],
        required: true,
        default: null
    },
    names: {
        type: Array,
        required: false,
        default: null
    }
});

const emit = defineEmits(['close']);

const close = () => {
    emit('close');
};

const variables = computed(() => {
    return {
        name: props.names,
        guidelineId: props.guidelineId
    };
});

const response = await useLazyAsyncQuery({
    query: ReferenceTooltipQuery,
    variables
});

const { data, pending } = response;

const references = computed(() => {
    if (!data) {
        return [];
    }
    return data.value?.references;
});
</script>

<style lang="less">
.guideline-reference-tooltip {
    position: sticky;
    bottom: 0;
    left: 0;

    background-color: var(--color-gray-200);
    box-shadow: var(--boxShadow-base);
}

.guideline-reference-tooltip__header {
    display: flex;
    align-items: center;
    padding: 1rem;
    border-radius: var(--borderRadius-sm) var(--borderRadius-sm) 0 0;
    background: var(--color-darkest);

    h4 {
        flex: 1 0 auto;
        color: var(--color-lightest);
    }
}

.guideline-reference-tooltip__content {
    padding: 1.25rem;
    max-height: 33vh;
    overflow: auto;

    p {
        font-size: var(--font-size-xs);
        line-height: var(--lineHeight-lg);

        @media @q-lg-min {
            font-size: var(--font-size-sm);
        }
    }
}

.guideline-reference-tooltip__close {
    color: var(--color-lightest);
    font-size: 1.5rem;
    height: 1.5rem;

    .dn-icon {
        line-height: 0;
    }
}
</style>
